module.exports = __webpack_public_path__ + "img/Social Media Publishing.a868370f.png";